/* @flow */
import moment from 'moment';

import navigation from 'services/NavigationService';
import { apiService } from 'services/ServiceRegistry';
import { activities } from 'components/Activity/ActivityData.js';
import { translate as translateStatus } from 'utils/statuses';

import Form from '../_.extend';

export const makeFields: Function = (projectData: Object, t: Function) => {
  let costCentersStr: string = '';
  let engineersStr: string = '';

  if (projectData && projectData.cost_centres && projectData.cost_centres.length > 0) {
    for (let i: * = 0; i < projectData.cost_centres.length; i++) {
      costCentersStr !== '' && (costCentersStr += ',');
      costCentersStr += projectData.cost_centres[i].id;
    }
  }

  if (projectData && projectData.engineers && projectData.engineers.length > 0) {
    for (let i: * = 0; i < projectData.engineers.length; i++) {
      engineersStr !== '' && (engineersStr += ',');
      engineersStr += projectData.engineers[i].id;
    }
  }

  return [
    {
      // CHOOSE ACCOUNT
      name: 'chooseAccount',
      label:
        projectData && projectData.trading_account
          ? t('general:trading_account')
          : t('general:actions.choose_account'),
      fields: [
        {
          name: 'tradingAccount',
          label: t('general:actions.choose_trading_account'),
          rules: 'required|string',
          value:
            projectData && projectData.trading_account ? projectData.trading_account.name : null,
          extra: {
            selectID:
              projectData && projectData.trading_account ? projectData.trading_account.id : null,
          },
        },
      ],
    },
    {
      // PROJECT DETAIL
      name: 'projectDetails',
      label: t('general:projects.labels.details'),
      fields: [
        {
          name: 'projectCode',
          label: t('general:projects.labels.code'),
          rules: 'required|string',
          value: projectData ? projectData.code : null,
        },
        {
          name: 'projectName',
          label: t('general:projects.labels.name'),
          rules: 'required|string',
          value: projectData ? projectData.name : null,
        },
        {
          name: 'projectDescription',
          label: t('general:projects.labels.description'),
          rules: 'string',
          multiline: true,
          value: projectData ? projectData.description : null,
        },
        {
          name: 'projectStartDate',
          label: t('general:projects.labels.start_date'),
          rules: 'required|date',
          // placeholder: 'Select start date',
          value:
            projectData && projectData.start_date
              ? moment(projectData.start_date, 'YYYY-MM-DD').toDate()
              : '',
          related: ['projectDetails.projectEndDate'],
        },
        {
          name: 'projectEndDate',
          label: t('general:projects.labels.end_date'),
          rules: 'required|date|date_after_field:projectDetails.projectStartDate',
          // placeholder: 'Select end date',
          value:
            projectData && projectData.end_date
              ? moment(projectData.end_date, 'YYYY-MM-DD').toDate()
              : '',
        },
        {
          name: 'chooseLead',
          label: t('general:actions.choose_project_lead'),
          rules: 'required|string',
          value: projectData && projectData.project_lead ? projectData.project_lead.id : null,
          extra: {
            selectID: projectData && projectData.project_lead ? projectData.project_lead.id : null,
            parentId:
              projectData && projectData.trading_account ? projectData.trading_account.id : null,
          },
        },
        {
          name: 'chooseStatus',
          label: t('general:projects.labels.status'),
          rules: 'string',
          value: projectData ? projectData.status : null,
          options: [
            {
              id: 'Active',
              name: translateStatus('active', { t }),
            },
            {
              id: 'Disabled',
              name: translateStatus('disabled', { t }),
            },
            {
              id: 'Archived',
              name: translateStatus('archived', { t }),
            },
            {
              id: 'Scheduled',
              name: translateStatus('sheduled', { t }),
            },
            {
              id: 'Ended',
              name: translateStatus('ended', { t }),
            },
          ],
        },
      ],
    },
    {
      // ASSIGN COST CENTERS
      name: 'assignCostCentre',
      label: t('general:actions.assign_cost_center_plural'),
      fields: [
        {
          name: 'costCentreAssign',
          label: t('general:actions.choose_cost_centers'),
          rules: 'string',
          placeholder: 'Cost center name or description...',
          value: costCentersStr,
          extra: {
            selectID: null,
            parentId:
              projectData && projectData.trading_account ? projectData.trading_account.id : null,
            actionButton: true,
          },
        },
      ],
    },
    {
      // ASSIGN PROJECT ENGINEERS
      name: 'assignProjectEngineers',
      label: t('general:actions.assign_project_engineer_plural'),
      fields: [
        {
          name: 'projectEngineer',
          label: t('general:actions.choose_project_engineers'),
          rules: 'string',
          value: engineersStr,
          extra: {
            selectID: null,
            parentId:
              projectData && projectData.trading_account ? projectData.trading_account.id : null,
            actionButton: true,
          },
        },
      ],
    },
    {
      // PROJECT LOCATION DETAIL SECTION
      name: 'location',
      label: projectData.id
        ? t('general:actions.change_location')
        : t('general:projects.labels.location'),
      fields: [
        {
          name: 'countryId',
          value:
            projectData && projectData.location && projectData.location.site
              ? projectData.location.site.country_id
              : null,
          rules: 'string',
        },
        {
          name: 'locationSiteId',
          value: '',
          rules: 'string',
        },
        {
          name: 'locationCompany',
          label: t('general:company'),
          rules: 'required|string',
          value:
            projectData && projectData.location && projectData.location.company
              ? projectData.location.company.name
              : null,
          extra: {
            selectID:
              projectData && projectData.location && projectData.location.company
                ? projectData.location.company.id
                : null,
            parentId:
              projectData && projectData.trading_account ? projectData.trading_account.id : null,
            actionButton: true,
            setSelectedFields: [
              {
                field: 'locationSite',
                value: null,
              },
              {
                field: 'locationBuilding',
                value: null,
              },
              {
                field: 'locationRoom',
                value: null,
              },
              {
                field: 'locationSystem',
                value: null,
              },
            ],
          },
        },
        {
          name: 'locationSite',
          label: t('general:locations.labels.site'),
          rules: 'required|string',
          value:
            projectData && projectData.location && projectData.location.site
              ? projectData.location.site.name
              : null,
          extra: {
            selectID:
              projectData && projectData.location && projectData.location.site
                ? projectData.location.site.id
                : null,
            parentId:
              projectData &&
              projectData.location &&
              projectData.location.site &&
              projectData.location.company.id,
            actionButton: true,
            setSelectedFields: [
              {
                field: 'countryId',
                value: 'country_id',
              },
              {
                field: 'locationBuilding',
                value: null,
              },
              {
                field: 'locationRoom',
                value: null,
              },
              {
                field: 'locationSystem',
                value: null,
              },
            ],
            childExtraFilters: [
              {
                type: 'formField',
                formName: 'location',
                formField: 'locationCompany',
                isExtra: true,
                value: 'selectID',
              },
              {
                type: 'formField',
                formName: 'location',
                formField: 'countryId',
                isExtra: false,
                value: 'value',
              },
              {
                type: 'string',
                value: '?parent_id=',
              },
            ],
          },
        },
        {
          name: 'locationBuilding',
          label: t('general:locations.labels.building_transport'),
          value:
            projectData && projectData.location && projectData.location.building
              ? projectData.location.building.name
              : null,
          rules: 'string',
          extra: {
            selectID:
              projectData && projectData.location && projectData.location.building
                ? projectData.location.building.id
                : null,
            parentId:
              projectData && projectData.location && projectData.location.building
                ? `/${projectData.location.company.id}` +
                  `/${projectData.location.site.country_id}` +
                  `?parent_id=${projectData.location.site.id}`
                : null,
            actionButton: true,
            setSelectedFields: [
              {
                field: 'locationRoom',
                value: null,
              },
              {
                field: 'locationSystem',
                value: null,
              },
            ],
            childExtraFilters: [
              {
                type: 'formField',
                formName: 'location',
                formField: 'locationCompany',
                isExtra: true,
                value: 'selectID',
              },
              {
                type: 'formField',
                formName: 'location',
                formField: 'countryId',
                isExtra: false,
                value: 'value',
              },
              {
                type: 'string',
                value: '?parent_id=',
              },
            ],
          },
        },
        {
          name: 'locationRoom',
          label: t('general:locations.labels.lab_room'),
          value:
            projectData && projectData.location && projectData.location.room.id
              ? projectData.location.room.name
              : null,
          rules: 'string',
          extra: {
            selectID:
              projectData && projectData.location && projectData.location.room.id
                ? projectData.location.room.id
                : null,
            parentId:
              projectData && projectData.location && projectData.location.room.id
                ? `/${projectData.location.company.id}` +
                  `/${projectData.location.site.country_id}` +
                  `?parent_id=${projectData.location.building.id}`
                : null,
            actionButton: true,
            setSelectedFields: [
              {
                field: 'locationSystem',
                value: null,
              },
            ],
            childExtraFilters: [
              {
                type: 'formField',
                formName: 'location',
                formField: 'locationCompany',
                isExtra: true,
                value: 'selectID',
              },
              {
                type: 'formField',
                formName: 'location',
                formField: 'countryId',
                isExtra: false,
                value: 'value',
              },
              {
                type: 'string',
                value: '?parent_id=',
              },
            ],
          },
        },
        {
          name: 'locationSystem',
          label: t('general:locations.labels.system_workspace'),
          value:
            projectData && projectData.location && projectData.location.workspace.id
              ? projectData.location.workspace.name
              : null,
          rules: 'string',
          extra: {
            selectID:
              projectData && projectData.location && projectData.location.workspace.id
                ? projectData.location.workspace.id
                : null,
            parentId:
              projectData && projectData.location && projectData.location.workspace.id
                ? `/${projectData.location.company.id}` +
                  `/${projectData.location.site.country_id}` +
                  `?parent_id=${projectData.location.room.id}`
                : null,
            actionButton: true,
          },
        },
        {
          name: 'streetNumber',
          label: t('general:labels.street_number'),
          rules: 'string',
          value: '',
        },
        {
          name: 'town',
          label: t('general:town_city'),
          rules: 'string',
          value: '',
        },
        {
          name: 'state',
          label: t('general:state_county_province'),
          rules: 'string',
          value: '',
        },
        {
          name: 'postCode',
          label: t('general:zip_postcode'),
          rules: 'string',
          value: '',
        },
        {
          name: 'country',
          label: t('general:country'),
          rules: 'string',
          value: '',
        },
        {
          name: 'phone',
          label: t('general:labels.contact_phone_number'),
          rules: 'telephone',
          value: '',
        },
        {
          name: 'fax',
          label: t('general:labels.contact_fax_number'),
          rules: 'telephone',
          value: '',
        },
      ],
    },
    {
      // ADITIONAL INFORMATION
      name: 'additionalInformation',
      label: t('general:additional_info'),
      fields: [
        {
          name: 'comments',
          label: t('general:labels.comments'),
          rules: 'string',
          multiline: true,
          value: projectData ? projectData.additional_info : null,
        },
      ],
    },
  ];
};

class ProjectFormCreate extends Form {}

class ProjectFormEdit extends Form {}

export const projectCreate: Function = (fields: Array<*>, localState: Object, t: Function) => {
  const hooks: Object = {
    onSuccess(form: Object) {
      localState.isLoading = true;
      localState.responseMessage = t('general:messages.saving_form');
      localState.showResponseMessage = true;
      localState.hasError = false;
      localState.hasSuccess = true;

      const { account }: Object = form.values().chooseAccount;

      const {
        projectCode,
        projectName,
        projectDescription,
        projectStartDate,
        projectEndDate,
      }: Object = form.values().projectDetails;

      const { costCentreAssign }: Object = form.values().assignCostCentre;

      const { projectEngineer }: Object = form.values().assignProjectEngineers;

      const { comments }: Object = form.values().additionalInformation;

      const vLocationId: string =
        form.$('location.locationSystem').extra.selectID ||
        form.$('location.locationRoom').extra.selectID ||
        form.$('location.locationBuilding').extra.selectID ||
        form.$('location.locationSite').extra.selectID ||
        form.$('location.locationCompany').extra.selectID;

      const arrCostCentreAssign = costCentreAssign ? costCentreAssign.split(',') : [];
      const arrProjectEngineer = projectEngineer ? projectEngineer.split(',') : [];

      const jsonObj: Object = {
        activity_tag: activities.createdProject.tag, // eslint-disable-line camelcase
        account_id: form.$('chooseAccount.tradingAccount').extra.selectID,
        code: projectCode,
        name: projectName,
        description: projectDescription,
        start_date: moment(projectStartDate).format('MMMM DD, YYYY'),
        end_date: moment(projectEndDate).format('MMMM DD, YYYY'),
        assignee_id: form.$('projectDetails.chooseLead').extra.selectID,

        cost_centres: arrCostCentreAssign,
        engineer_ids: arrProjectEngineer,

        location_id: vLocationId,
        additional_info: comments,
      };

      !comments && delete jsonObj.additional_info;
      !projectDescription && delete jsonObj.description;

      apiService
        .createResource('projects', jsonObj)
        .then((response: Object) => {
          localState.isLoading = false;
          localState.responseMessage = t('general:messages.save_success');

          setTimeout(() => {
            localState.showResponseMessage = false;
            /*eslint-disable max-nested-callbacks*/
            setTimeout(() => {
              // Snackbar animation 225ms
              navigation.goBack();
            }, 225);
          }, 1200);

          return response;
        })

        .catch((err: string) => {
          localState.isLoading = false;
          localState.responseMessage = t('general:messages.save_error');
          localState.hasSuccess = false;
          localState.hasError = true;
        });
    },
    onError(form: Object) {
      localState.isLoading = false;
      localState.responseMessage = t('general:messages.form_error');
      localState.showResponseMessage = true;
      localState.hasSuccess = false;
      localState.hasError = true;
    },
  };

  return new ProjectFormCreate(
    { fields },
    { hooks, name: t('general:actions.create_new_project') }
  );
};

export const projectEdit: Function = (
  fields: Array<*>,
  projectData: Object,
  localState: Object,
  t: Function
) => {
  const hooks: Object = {
    onSuccess(form: Object) {
      localState.isLoading = true;
      localState.responseMessage = t('general:messages.saving_form');
      localState.showResponseMessage = true;
      localState.hasError = false;
      localState.hasSuccess = true;

      const {
        projectCode,
        projectName,
        projectDescription,
        projectStartDate,
        projectEndDate,
      }: Object = form.values().projectDetails;

      const { costCentreAssign }: Object = form.values().assignCostCentre;

      const { projectEngineer }: Object = form.values().assignProjectEngineers;

      const { comments }: Object = form.values().additionalInformation;

      const vLocationId: string =
        form.$('location.locationSystem').extra.selectID ||
        form.$('location.locationRoom').extra.selectID ||
        form.$('location.locationBuilding').extra.selectID ||
        form.$('location.locationSite').extra.selectID ||
        form.$('location.locationCompany').extra.selectID;

      const arrCostCentreAssign = costCentreAssign ? costCentreAssign.split(',') : [];
      const arrProjectEngineer = projectEngineer ? projectEngineer.split(',') : [];

      const jsonObj: Object = {
        activity_tag: activities.edited.tag, // eslint-disable-line camelcase
        account_id: form.$('chooseAccount.tradingAccount').extra.selectID,
        code: projectCode,
        name: projectName,
        description: projectDescription,
        start_date: moment(projectStartDate).format('MMMM DD, YYYY'),
        end_date: moment(projectEndDate).format('MMMM DD, YYYY'),
        assignee_id: form.$('projectDetails.chooseLead').extra.selectID,

        cost_centres: arrCostCentreAssign,
        engineer_ids: arrProjectEngineer,

        location_id: vLocationId,
        additional_info: comments,
      };

      apiService
        .putResource(`projects/${projectData.id}`, jsonObj)
        .then((response: Object) => {
          localState.isLoading = false;
          localState.responseMessage = t('general:messages.save_success');

          setTimeout(() => {
            localState.showResponseMessage = false;
            /*eslint-disable max-nested-callbacks*/
            setTimeout(() => {
              // Snackbar animation 225ms
              navigation.goBack();
            }, 225);
          }, 1200);

          return response;
        })

        .catch((err: string) => {
          localState.isLoading = false;
          localState.responseMessage = t('general:messages.save_error');
          localState.hasSuccess = false;
          localState.hasError = true;
        });
    },
    onError(form: Object) {
      localState.isLoading = false;
      localState.responseMessage = t('general:messages.form_error');
      localState.showResponseMessage = true;
      localState.hasSuccess = false;
      localState.hasError = true;
    },
  };

  return new ProjectFormEdit({ fields }, { hooks, name: t('general:actions.edit_project') });
};
